import { useState } from 'react'


import { withUIContext } from 'context'
import { Text, Icon, FollowersPopup } from 'components/common'

const ProfileTopBar = ({ winWidth, toggleFollowersPopup, disableDomScroll, profile }) => {
    const [popupType, setPopupTpe] = useState()

    const handleFollowersPopUp = (type) => {
        if (profile[`${type}Count`] > 0) {
            toggleFollowersPopup();
            disableDomScroll();
            setPopupTpe(type);
        }
    }

    return (
        <div className={'profileMenuCont flexBox'}>
            <FollowersPopup
                follows={profile[popupType]}
                popupType={popupType}
            />
            <div className="big-block flexBox">
                <div className="spacing" />
                <div className="info flexBox">
                    <div className="single-menu-item flexBox cursorPointer" onClick={() => handleFollowersPopUp('followers')}>
                        <Text tag={'h5'} className={'value h5 PopSemi'} text={profile.followersCount} />
                        {winWidth > 601 ? (
                            <Text tag={'h5'} className={'key h5 PopSemi'} text={'Followers'} />
                        ) : (
                            <Icon className="op-personArrowLeft" />
                        )}
                    </div>
                    <div className="single-menu-item flexBox cursorPointer" onClick={() => handleFollowersPopUp('following')}>
                        <Text tag={'h5'} className={'value h5 PopSemi'} text={profile.followingCount} />
                        {winWidth > 601 ? (
                            <Text tag={'h5'} className={'key h5 PopSemi'} text={'Following'} />
                        ) : (
                            <Icon className="op-personArrowRight" />
                        )}
                    </div>
                    <div className="single-menu-item flexBox">
                        <Text tag={'h5'} className={'value h5 PopSemi'} text={profile.debatesCount} />
                        {winWidth > 601 ? (
                            <Text tag={'h5'} className={'key h5 PopSemi'} text={'Debates created'} />
                        ) : (
                            <Icon className="op-message" />
                        )}
                    </div>
                    <div className="single-menu-item flexBox">
                        <Text tag={'h5'} className={'value h5 PopSemi'} text={profile.topRatedCount} />
                        {winWidth > 601 ? (
                            <Text tag={'h5'} className={'key h5 PopSemi'} text={'Times top rated'} />
                        ) : (
                            <Icon className="op-like" />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withUIContext(ProfileTopBar, ['winWidth', 'toggleFollowersPopup', 'disableDomScroll'])
